// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AccueilPlanning_heure__CriRx {\n  background-color: var(--background-heure-normal);\n}\n.AccueilPlanning_event__2iacy {\n  background-color: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Accueil/AccueilPlanning.module.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD;AACA;EACE,kDAAkD;AACpD","sourcesContent":[".heure {\n  background-color: var(--background-heure-normal);\n}\n.event {\n  background-color: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heure": "AccueilPlanning_heure__CriRx",
	"event": "AccueilPlanning_event__2iacy"
};
export default ___CSS_LOADER_EXPORT___;
